import React from 'react';
import { useSetResolved } from 'src/core/engine/router';
import { IndividualPage } from 'src/components/IndividualPage/IndividualPage';
import { CategoryQueryProvider } from 'src/components/CategoryListingPage/CategoryQueryProvider';
import { useSetPopupPageCategory } from 'src/components/PopupBanner/PopupPageContext';

interface Props {
    id: number;
}

const EMPTY_PARENT_IDS: number[] = [];

export const IndividualRoot: React.FC<Props> = (props) => {
    useSetResolved();
    useSetPopupPageCategory(props.id, EMPTY_PARENT_IDS);

    return (
        <CategoryQueryProvider id={props.id}>
            <IndividualPage />
        </CategoryQueryProvider>
    );
};

export default IndividualRoot;
